import FormattedBankAccount from "./FormattedBankAccount";

export default FormattedBankAccount;
